export const providerCategory = {
  CREDITCARD: 'Credit Card',
  WALLET: 'Wallet',
  CRYPTO: 'Crypto',
  OTHER: 'Other',
  INSTANTBANKING: 'Instant Banking',
  VOUCHER: 'Voucher'
}
